import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React from 'react'
import { useState } from 'react';
import { GetDisConnDev } from '../../services/LoginPageService';
import { useEffect } from 'react';

const DisRowClick = ({openDis, setOpenDis,disData,setRefreshData}) => {
    const [resfeshIn,setRefreshIn] = useState(false);
    const [rows, setRows] = useState([]);

    const columns = [
        {   field: 'facultyId', headerName: 'Faculty Id', 
            minWidth: 100, flex: 1, align: 'center', headerAlign: 'center' },
        {   field: 'facultyName', headerName: 'Faculty Name', 
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center' },
        {   field: 'subjects', headerName: 'Subject', 
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center' },
    ];

    useEffect(()=>{
        if(disData)
        {
            GetDisConnDev({
                id: disData?.id},
            handleGetDisConnDevShowData,handleGetDisConnDevException);
        }
    },[disData]);

    const handleGetDisConnDevShowData=(dataObject)=>{
        setRows(dataObject?.data)
    }

    const handleGetDisConnDevException=(errorObject,errorMessage)=>{
        console.log(errorMessage);
    }

    const handleClose = () => {
        setOpenDis(false);  
    };

    return (
        <div>
            <Dialog sx={{ '& .MuiDialog-paper': { width: '60%', maxHeight: '100%' } }}
            fullWidth
            maxWidth='lg'
            open={openDis}>
                <form>
                    <DialogTitle style={{background:'#f7f7f7',color:'black',display:"flex",justifyContent:"space-between"}}>
                        <Typography sx={{ m: 1 }} variant="h5">
                        Device Id - {disData?.deviceId}
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={1} style={{ marginTop: '20px' }}>
                            <Grid item xs={12} sm={12} md={12} lg={12} lx={12}>
                                <DataGrid 
                                style={{ height: 300,width:'100%' }}
                                // loading={loading}
                                rows={rows}
                                columns={columns}
                                pageSize={8}
                                rowsPerPageOptions={[8]}
                                disableSelectionOnClick
                                sx={{
                                height: '480px',
                                width: '100%',
                                '& .super-app-theme--header': {
                                  WebkitTextStrokeWidth:'0.6px',             
                                },
                              }}/>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    )
}

export default DisRowClick
